export default {
  landingPath: process.env.REACT_APP_INDEX_PATH || "/renters",
  noApartmentPath: process.env.REACT_APP_NO_APARTMENT_PATH || "/renters/no-apartment",
  unenrolledBuildingPath: process.env.REACT_APP_UNENROLLED_PATH || "/renters/qualify",
  faqPath: `${process.env.REACT_APP_MONOLITH_URL || ""}/faq`,
  signinPath: `${process.env.REACT_APP_MONOLITH_URL || ""}/login`,
  signupPath: `${process.env.REACT_APP_MONOLITH_URL || ""}/sign-up`,
  thanksPath: process.env.REACT_APP_THANKS_PATH || "/renters/thanks",
  operatorsPath: process.env.REACT_APP_OPERATORS_PATH || "/operators",
  renterPath: process.env.REACT_APP_RENTER_PATH || "/renter",
  brokerPath: process.env.REACT_APP_BROKER_PATH || "/brokers",
  faqRenterPath: process.env.REACT_APP_FAQRENTER_PATH || "/faq-renters",
  theWelcomeMatPath: process.env.REACT_APP_WELCOMEMAT_PATH || "https://www.theguarantors.com/blog",
  aboutPath: process.env.REACT_APP_ABOUT_PATH || "/about",
  careerPath: process.env.REACT_APP_CAREER_PATH || "https://careers.theguarantors.com",
  pressPath: process.env.REACT_APP_PRESS_PATH || "/press",
  contactPath: process.env.REACT_APP_CONTACT_PATH || "/contact-us",
  getStartedPath: process.env.REACT_APP_GETSTARTED_PATH || "/get-started",
  trustCenterPath: process.env.REACT_APP_TRUST_CENTER_PATH || "https://trust.theguarantors.com",
  privacyPath: process.env.REACT_APP_PRIVACY_PATH || "/privacy",
  tosPath: process.env.REACT_APP_TOS_PATH || "/terms",
  legalRegulatoryPath: process.env.REACT_APP_LEGAL_REGULATORY_PATH || "/legal-regulatory",
  noticeOfCollectionPath: process.env.REACT_APP_NOTICE_OF_COLLECTION_PATH || "/notice-of-collection",
  partnersPath: process.env.REACT_APP_PARTNERS_PATH || "/partners",
  newRentersFlow: `${process.env.REACT_APP_MSA_PATH}/renters` ?? 'https://qualify.theguarantors.com/renters',
  newUnenrolledFlow: `${process.env.REACT_APP_MSA_PATH}/unenrolled` ?? 'https://qualify.theguarantors.com/unenrolled',
}

export const linkTitles = {
  about: "About",
  contact: "Contact Us",
  careers: "Careers",
  press: "Press",
  renters: "Renters",
  operators: "Owners & Operators",
  broker: "Brokers",
  theWelcomeMat: "The Welcome Mat",
  blog: "Blog",
  privacy: "Privacy Policy",
  tos: "Terms of Service",
  legalRegulatory: "Legal/Regulatory Notice",
  faq: "FAQ",
  noticeOfCollection: "Notice of Collection",
  trustCenter: "Trust Center",
  partners: "Shop Our Partners"
}
